import { FieldDescription, FieldError, FieldLabel, fieldIds, fieldInputClass, fieldTextareaClass } from './shared';
import type { FieldProps } from './FieldProps';

/** Short text ({type: string}) or long text ({type: string}, widget hint "textarea"). */
export function TextField({ field, value, error, onChange }: FieldProps) {
  const { inputId, descriptionId, errorId } = fieldIds(field.path);
  const stringValue = typeof value === 'string' ? value : '';
  const describedBy = [field.schema.description ? descriptionId : null, error ? errorId : null]
    .filter(Boolean)
    .join(' ');

  return (
    <div>
      <FieldLabel htmlFor={inputId} required={field.required}>
        {field.schema.title ?? field.key}
      </FieldLabel>
      <FieldDescription id={descriptionId} text={field.schema.description} />
      {field.kind === 'textarea' ? (
        <textarea
          id={inputId}
          rows={3}
          className={fieldTextareaClass}
          value={stringValue}
          onChange={(event) => onChange(event.target.value)}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy || undefined}
        />
      ) : (
        <input
          id={inputId}
          type="text"
          className={fieldInputClass}
          value={stringValue}
          onChange={(event) => onChange(event.target.value)}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy || undefined}
        />
      )}
      <FieldError id={errorId} message={error} />
    </div>
  );
}
